import { request } from "@/utils/remoteRequest";

export function searchRoles(data) {
  return request({
    url: "/authManage/searchRoles",
    method: "post",
    data,
  });
}
